import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState
} from 'react'

interface FormDirtyProps {
  isDirty: boolean
  setIsDirty: Dispatch<SetStateAction<boolean>>
}

const initialState: FormDirtyProps = {
  isDirty: false,
  setIsDirty: () => {}
}

const FormDirtyContext = createContext(initialState)

/**
 * FormDirtyProvider provides a context for form dirty state tracking.
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The child components.
 * @returns {ReactElement} The rendered component.
 */
export default function FormDirtyProvider({
  children
}: {
  children: ReactNode
}) {
  const [isDirty, setIsDirty] = useState(false)

  return (
    <FormDirtyContext.Provider value={{ isDirty, setIsDirty }}>
      {children}
    </FormDirtyContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useFormDirty() {
  return useContext(FormDirtyContext)
}
